export default __webpack_public_path__ + "static/media/2.a0ff24b2.jpg";